import { render } from "./HomeSpl.vue?vue&type=template&id=0d8fc423"
import script from "./HomeSpl.vue?vue&type=script&lang=js"
export * from "./HomeSpl.vue?vue&type=script&lang=js"

import "./HomeSpl.vue?vue&type=style&index=0&id=0d8fc423&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__